import { useSelector, useDispatch } from 'react-redux';
import { useModals } from '@mattjennings/react-modal-stack';
import { useJsApiLoader, GoogleMap, Marker, DirectionsService, DirectionsRenderer, DirectionsResult } from "@react-google-maps/api";
import { GOOGLE_MAPS_API_KEY } from '../api';
import { updateQueryRoute } from '../store/knownDataSlice';
import Resizable from './Resizable';
import RouteScreen from './inquery/RouteScreen';
import RouteMap from './inquery/RouteMap';
import RouteDisplay from './inquery/RouteDisplay';
import '../components/inquery/Maps.css';
import { useEffect, useState } from 'react';
import { restart, setWaypoints } from '../store/inquerySlice';
import { unwrapResult } from '@reduxjs/toolkit';
import { toast } from 'react-toastify';
import { DataContainer } from './DataContainer';

const GOOGLE_LIBRARIES = ['drawing', 'geometry', 'maps', 'places'];

const SidePanelHandle = (props) => {
    return <div ref={props.innerRef} className="side-panel-handle" {...props} />;
};

function RouteEditor({ open, id }) {
    const { closeModal, openModal } = useModals();
    const dispatch = useDispatch();

    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: GOOGLE_MAPS_API_KEY,
        libraries: GOOGLE_LIBRARIES
    });

    const data = useSelector((state) => state.knownData[id]);
    const waypoints = useSelector((state) => state.inquery.waypoints);
    const route = JSON.parse(data.query_route);

    useEffect(() => {
        console.log("setting waypoints:", route);
        const newWaypoints = route.map((waypoint, index) => {
            return {
                id: index,
                formatted_address: waypoint.pretty_name,
                location: {
                    lat: waypoint.lat,
                    lng: waypoint.lng,
                },
                depart: waypoint.depart,
            };
        });
        dispatch(setWaypoints({
            waypoints: newWaypoints
        }));
    }, [data, open]);

    async function onSave() {
        const res = await unwrapResult(await dispatch(updateQueryRoute({
            id,
            waypoints: JSON.stringify(waypoints.map(p => ({
                lat: p.location.lat,
                lng: p.location.lng,
                depart: p.depart,
                //arrive: p.arrive,
                city_name: p.city_name,
                pretty_name: p.formatted_address,
            }))),
            notifyByEmail: false,
        })));
        if(!res) toast.error("Marsruudi muutmine ebaõnnestus");

        await unwrapResult(await dispatch(restart()));

        closeModal();
    }

    if(!isLoaded) return (<></>);

    if (!open) return null;

    return (
        <div className="modal inquery" style={{ pointerEvents: 'auto' }}>
            <div className="container column" style={{ width: 'calc(100vw - 32px * 2)', height: 'calc(100vh - 32px * 2)'}}>
                <div className="row" style={{ justifyContent: 'flex-end', borderBottom: 'solid 1px #ddd' }}>
                    <div className="row center-main center-cross p8" onClick={closeModal} style={{ cursor: "pointer" }}>
                        <svg fill="#000" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50" width="16px" height="16px"><path d="M 7.71875 6.28125 L 6.28125 7.71875 L 23.5625 25 L 6.28125 42.28125 L 7.71875 43.71875 L 25 26.4375 L 42.28125 43.71875 L 43.71875 42.28125 L 26.4375 25 L 43.71875 7.71875 L 42.28125 6.28125 L 25 23.5625 Z" stroke='#888' strokeWidth={2}></path></svg>
                    </div>
                </div>
                <DataContainer actionType={"knownData/updateQueryRoute"} style={{ height: '100%' }}>
                    <div className='row' style={{ height: '100%' }}>
                        <Resizable direction='horizontal' handle={(handleAxis, ref) => <SidePanelHandle innerRef={ref} />}>
                            <div className="column" style={{ maxHeight: '100%' }}>
                                <div className="grow">
                                    <RouteDisplay/>
                                </div>
                                <div className="column g8">
                                    <button onClick={() => onSave()}>Salvesta</button>
                                </div>
                            </div>
                        </Resizable>

                        <RouteMap />
                    </div>
                </DataContainer>
            </div>
        </div>
    );
};

export default RouteEditor;